import { GoogleMapsLoaderService } from '../../services/google-maps-loader.service';
import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Airport, Booking, City, Coordinates, Country} from '../../../models/business-objects';
import {BookingService} from '../../services/booking.service';
import {MatDialog} from '@angular/material/dialog';
import {MapPopupComponent} from '../map-popup/map-popup.component';
import {LocationService} from '../../services/location.service';
import {DURATIONS, HOURS, TIMES} from '../../../models/constants';
import {isPlatformBrowser} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {BehaviorSubject, combineLatest, firstValueFrom, forkJoin, Observable, Subscription} from 'rxjs';
import {filter, take} from 'rxjs/operators';
import {ThemePalette} from '@angular/material/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import {MatStepperModule} from '@angular/material/stepper';

@Component({
  selector: 'app-booking-widget',
  templateUrl: './booking-widget.component.html',
  styleUrls: ['./booking-widget.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    NgbDatepickerModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    LocalizeRouterModule,
    MatStepperModule
  ],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  hours = HOURS;
  durations = DURATIONS;
  times = TIMES;
  zoom = 1;
  isAirportPickup = false;

  map: google.maps.Map;
  private subscriptions: Subscription[] = [];
  private geoCoder;
  @Input() insideStepper: boolean;
  @Input() format: string;
  @Input() cityInURL: string;
  @Input() clientCity: string;
  @Output() widgetEvent = new EventEmitter<boolean>();

  @ViewChild('pudate')
  public pudate: HTMLInputElement;
  bookingForm: FormGroup;
  readyForSubmission = false;
  required = 'This information is required';
  resultDisplay = 'none';
  resultText = '';
  resultClass = '';
  booking: Booking;
  mapPopupComponent = MapPopupComponent;
  submitted = false;
  autocompletePu: google.maps.places.Autocomplete = null;
  autocompleteDo: google.maps.places.Autocomplete = null;
  autocompleteListenerPu;
  autocompleteListenerDo;
  flightNumber: string;
  airportCode: string;
  hoy = new Date();
  mindate: NgbDateStruct;
  requestedCity: City;
  cities: City[];
  countries: Country[];
  allCities: City[];
  allAirports: Airport[];
  color: ThemePalette = 'primary';
  checked = false;
  puDisabled = false;
  maxRadiusForPuLocation = 100000; // 100 km
  maxRadiusForDoLocation = 800000; // 800 km
  @ViewChild('nextButton', {static: false}) nextButton: ElementRef;
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;
  private mapInitialized = new BehaviorSubject<boolean>(false);
  private componentDataLoaded = new BehaviorSubject<boolean>(false);
  private pendingBookingData: Booking | null = null;
  isLoading = true;

  @ViewChild('searchPu')
  set searchPu(elementRef: ElementRef) {
    if (elementRef) {
      this.googleMapsLoader.mapReady$.pipe(
        filter(google => !!google),
        take(1)
      ).subscribe(() => {
        this.createListenersOnPU(elementRef);
      });
    }
  }

  @ViewChild('searchDo')
  set searchDo(elementRef: ElementRef) {
    if (elementRef) {
      this.googleMapsLoader.mapReady$.pipe(
        filter(google => !!google),
        take(1)
      ).subscribe(() => {
        this.createListenersOnDO(elementRef);
      });
    }
  }

  constructor(private router: Router, private formBuilder: FormBuilder, private bookingData: BookingService,
              public dialog: MatDialog, private ngZone: NgZone, private ref: ChangeDetectorRef,
              private translate: TranslateService, private localize: LocalizeRouterService, private el: ElementRef,
              private locationService: LocationService, @Inject(PLATFORM_ID) private platformId: any,
              private googleMapsLoader: GoogleMapsLoaderService) {
    this.insideStepper = false;
    this.translate.setDefaultLang('en');
    if ( this.booking == null) { this.booking = new Booking(); }
    this.countries = [];
    this.cities = [];
   }

  ngOnInit() {
    this.createFormGroup(this.formBuilder); // Form is created here
    console.log('construyendo el booking widget con  cityInURL and clientCity : ' + this.cityInURL + ' ' + this.clientCity);
    if (isPlatformBrowser(this.platformId)) {
      console.log('scrolling to top  BookingStep2Component');
      window.scrollTo(0, 0);
    }
    // Initialize with empty data
    this.countries = [];
    this.allCities = [];
    this.allAirports = [];

    // Load data asynchronously without blocking
    this.locationService.waitForInitialization().then(() => {
      this.loadLocationData().then(() => {
        this.componentDataLoaded.next(true);
      });
    });

    // Continue with the rest of the initialization
    this.readyForSubmission = false;
    console.log('insideStepper in NgInit : ');
    console.log(this.insideStepper);
    this.mindate = {year: new Date().getFullYear(), month: (new Date().getMonth() + 1), day: new Date().getDate()};

    // Set up booking subscription with safer handling
    this.subscriptions.push(this.bookingData.currentBooking.subscribe(value => {
      console.log('New Booking received in widget');

      // Store the booking data but don't process it until everything is ready
      this.pendingBookingData = value;

      // Only process if all dependencies are already loaded.
      // This handles booking updates after initial load.
      if (this.componentDataLoaded.value && this.mapInitialized.value) {
        this.processPendingData();
      }
    }));
  }

  ngAfterViewInit() {
    this.googleMapsLoader.mapReady$.subscribe(google => {
        if (google) {
          this.mapInitializer();
        }
      }
    );

    // Wait for both data and map to be ready before setting up subscriptions
    this.subscriptions.push(
      combineLatest([this.componentDataLoaded, this.mapInitialized]).pipe(
        filter(([dataLoaded, mapLoaded]) => dataLoaded && mapLoaded),
        take(1)
      ).subscribe(() => {
        console.log('All dependencies ready. Setting up form logic.');
        this.setupFormSubscriptions();
        this.processPendingData(); // Process any initial data.
        this.isLoading = false;
        this.ref.detectChanges();
      })
    );
  }

  private processPendingData() {
    // Only process if we have pending data and both map and component data are ready
    if (!this.pendingBookingData ||
      !this.mapInitialized.value ||
      !this.componentDataLoaded.value) {
      return;
    }

    console.log('Processing pending booking data safely');
    this.booking = this.pendingBookingData;
    this.pendingBookingData = null; // Clear pending data

    // Update city information when data is available
    if (this.allCities && this.allCities.length > 0) {
      if (this.booking.serviceCity != null) {
        this.requestedCity = this.allCities.find(a => a.name === this.booking.serviceCity);
      } else if (this.cityInURL != null) {
        this.requestedCity = this.allCities.find(a => a.link === this.cityInURL);
        if (this.requestedCity != null) {
          this.booking.serviceCity = this.cityInURL;
        }
      } else if (this.clientCity != null) {
        this.requestedCity = this.allCities.find(a => a.name === this.clientCity);
        if (this.requestedCity != null) {
          this.booking.serviceCity = this.clientCity;
        }
      }
      if (this.requestedCity && this.requestedCity.country) {
        this.booking.serviceCountry = this.requestedCity.country.name;
      }
    }

    this.isAirportPickup = !!(this.booking.puGoogleLocation &&
      this.booking.puGoogleLocation.types.length > 0 &&
      this.booking.puGoogleLocation.types.includes('airport'));

    if (this.booking.searchType === 'List') { this.checked = true; }

    // Patch the form with the new booking data
    this.bookingForm.patchValue(this.booking, { emitEvent: false });

    // Update validators based on the new data
    this.updateValidators();


    this.addBoundToGooglePUListener();
    this.bookingForm.updateValueAndValidity();
    console.log('Booking received in widget');
    console.log(this.booking);
    if (this.bookingForm.status === 'VALID') {
      this.sendStepStatus(true);
      this.readyForSubmission = true;
    }
  }

  async mapInitializer() {
    if (isPlatformBrowser(this.platformId) && typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.Map === 'function') {
      if (!this.gmap) {
        console.error('Map container element is not available yet');
        return;
      }

      try {
        this.map = new google.maps.Map(this.gmap.nativeElement, null);
        this.geoCoder = new google.maps.Geocoder();
        // Mark map as initialized
        this.mapInitialized.next(true);

      } catch (error) {
        console.error('Error initializing Google Map:', error);
      }
    } else {
      console.error('Google Maps API not fully loaded yet in mapInitializer');
    }
  }

  createListenersOnPU(searchPuElement: ElementRef){
    if (!searchPuElement) {
      console.error('searchPu element not available');
      return;
    }
    this.autocompletePu = new google.maps.places.Autocomplete(searchPuElement.nativeElement);
    this.autocompleteListenerPu = google.maps.event.addListener(this.autocompletePu, 'place_changed',
      () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = this.autocompletePu.getPlace();
          // verify result
          if (place.geometry == null) {
            return;
          }
          let addressFieldText = '' ;
          if (place.name) { addressFieldText = place.name; }
          if (place.formatted_address) { addressFieldText += ' ' + place.formatted_address; }
          console.log('addressFieldText ' + addressFieldText);
          this.booking.puAdress = addressFieldText;
          console.log(place);
          console.log(place.types);
          if ( place.types && place.types.length > 0 && place.types.includes('airport')) {
            console.log('si se detecta aeropuerto');
            this.isAirportPickup = true;
            this.booking.isAirportPickup = true;
          } else {
            console.log('no se detecta aeropuerto');
            this.isAirportPickup = false;
            this.booking.isAirportPickup = false;
          }
          this.updateValidators();
          this.booking.puGoogleLocation = place;
          this.ref.detectChanges();
          // this.bookingForm.controls.puAdress.disable({});
          if (place.geometry.location) {
            this.booking.puCoordinates = new Coordinates();
            this.booking.puCoordinates.lat = place.geometry.location.lat();
            this.booking.puCoordinates.lng = place.geometry.location.lng();
            this.addBoundToGoogleDOListener();
          }
          if (this.booking.puGoogleLocation && this.booking.puGoogleLocation.address_components) {
            const serviceCity = this.locationService.extractCityFromGooglePlace(this.booking.puGoogleLocation);
            const serviceCountry = this.locationService.extractCountryFromGooglePlace(this.booking.puGoogleLocation);
            const city = this.allCities.find( a => a.name === serviceCity);
            const country = this.countries.find( a => a.name === serviceCountry);
            if (city != null) { this.requestedCity = city; }
          }
          console.log(place);
          this.zoom = 16;
        });
      });
    this.addCountryRestictionsToListeners();
    this.addBoundToGooglePUListener();
  }

  createListenersOnDO(searchDoElement: ElementRef){
    if (!searchDoElement) {
      console.error('searchDo element not available');
      return;
    }
    this.autocompleteDo = new google.maps.places.Autocomplete(searchDoElement.nativeElement);
    // this.addGenericListener(this.autocompleteDo, 'doAddress');
    this.autocompleteListenerDo = google.maps.event.addListener(this.autocompleteDo, 'place_changed',
      () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = this.autocompleteDo.getPlace();
          // verify result
          if (place.geometry ==  null) {
            return;
          }
          let addressFieldText = '' ;
          if (place.name) { addressFieldText = place.name; }
          if (place.formatted_address) { addressFieldText += ' ' + place.formatted_address; }
          console.log('addressFieldText ' + addressFieldText);
          this.booking.doAdress = addressFieldText;
          console.log(place);
          console.log(place.types);
          this.booking.doGoogleLocation = place;
          this.ref.detectChanges();
          // this.bookingForm.controls.doAdress.disable({});
          if (place.geometry.location) {
            this.booking.doCoordinates = new Coordinates();
            this.booking.doCoordinates.lat = place.geometry.location.lat();
            this.booking.doCoordinates.lng = place.geometry.location.lng();
          }
          console.log(place);
          this.zoom = 16;
        });
      });
    this.addCountryRestictionsToListeners();
    this.addBoundToGoogleDOListener();
  }

  bookingTypeChange(type) {
    if (!this.booking) {
      this.booking = new Booking();
    }
    const serviceTypeHasChanged = this.booking.serviceType !== type;
    this.booking.serviceType = type;
    if (serviceTypeHasChanged) {
      console.log('se cambia el typo de servicio a ' + type);
      if (this.booking.serviceType === 'transfer') {
        this.booking.duration = 1;
        this.booking.stops = [];
      } else {
        this.booking.duration = null;
      }
    }
    this.updateValidators();
  }

  createFormGroup(formBuilder: FormBuilder) {
    this.bookingForm = formBuilder.group({
      serviceCity: [null],
      serviceCountry: [null],
      searchMode: [true],
      puAdress: [null, Validators.required],
      doAdress: [null],
      puDate: [null, Validators.required],
      puHour: [null, Validators.required],
      puMin: [null, Validators.required],
      duration: [null],
      flightNumber: [null] // Always include flightNumber
    });
  }

  setupFormSubscriptions() {
    this.subscriptions.push (this.bookingForm.controls.puHour.valueChanges.subscribe(value => this.booking.puHour = value ));
    this.subscriptions.push (this.bookingForm.controls.puMin.valueChanges.subscribe(value => this.booking.puMin = value) );
    this.subscriptions.push ( this.bookingForm.controls.puDate.valueChanges.subscribe(value => {
      this.booking.puDate = value;
    }));
    this.subscriptions.push (this.bookingForm.controls.duration.valueChanges.subscribe(value => this.booking.duration = value));
    this.subscriptions.push (this.bookingForm.controls.flightNumber.valueChanges.subscribe(value => this.booking.flightNumber = value));
    this.subscriptions.push (this.bookingForm.controls.searchMode.valueChanges.subscribe(value =>  {
      if (value) {
        this.booking.searchType = 'List';
        if (this.requestedCity != null) {
          this.puDisabled = false;
        } else {
          if (this.booking.serviceCity != null) {
            this.requestedCity = this.allCities.find(a => a.name === this.booking.serviceCity);
            this.puDisabled = this.requestedCity == null;
          } else {
            this.puDisabled = true;
          }
        }
      } else {
        this.booking.searchType = 'Google';
        this.requestedCity = null;
        this.bookingForm.controls.serviceCity.setValue(null);
        this.bookingForm.controls.serviceCountry.setValue(null);
        this.removeBoundsToListeners();
      }
      this.addCountryRestictionsToListeners();
    }));
    this.subscriptions.push ( this.bookingForm.controls.serviceCountry.valueChanges.subscribe(data => {
      if (!data) {
        this.cities = this.allCities;
      } else {
        this.cities = this.allCities.filter((a) => a.country == null || a.country.name === data)
          .sort((a, b) => a.localName.localeCompare(b.localName));
      }
      let oldCountry = '';
      if (this.requestedCity != null) {
        oldCountry = this.requestedCity.country.name;
      }
      const newCountry = this.allCities.find(a => a.name === data);
      if (newCountry != null && newCountry.name !== oldCountry) {
        this.clearGooglePuPlace();
        this.clearGoogleDoPlace();
      }
      if (this.cities == null || this.cities.length === 0) {
        this.cities = this.allCities;
      }
      this.addCountryRestictionsToListeners();
    }));
    this.subscriptions.push ( this.bookingForm.controls.serviceCity.valueChanges.subscribe(data => {
      let oldCity = '' ;
      if ( this.requestedCity != null) { oldCity = this.requestedCity.name ; }
      this.requestedCity = this.allCities.find( a => a.name === data);
      if (this.requestedCity != null && this.requestedCity.name !== oldCity) {
        this.clearGooglePuPlace();
        this.bookingForm.controls.puAdress.setValue(null);
        this.clearGoogleDoPlace();
        this.bookingForm.controls.doAdress.setValue(null);
        const coordinates = new Coordinates();
        coordinates.lat = this.requestedCity.lat;
        coordinates.lng = this.requestedCity.lng;
        this.booking.puCoordinates = coordinates;
        this.booking.doCoordinates = coordinates;
      }
      if (this.requestedCity != null){
        this.puDisabled = false;
        this.booking.city = this.requestedCity;
      } else {
        this.booking.city = null;
        this.puDisabled = true;
      }
      if (this.bookingForm.controls.serviceCountry.value == null && this.requestedCity !== undefined) {
        this.bookingForm.controls.serviceCountry.setValue(this.requestedCity.country.name);
      }
      this.addBoundToGooglePUListener();
      this.addBoundToGoogleDOListener();
      this.addCountryRestictionsToListeners();
    }));
    this.subscriptions.push (this.bookingForm.statusChanges.subscribe(data => {
      if (data === 'VALID') {
        this.sendStepStatus(true);
        this.readyForSubmission = true;
      } else {
        this.sendStepStatus(false);
        this.readyForSubmission = false;
      }
    } ) );
    if ( this.submitted === true ) { this.bookingForm.markAllAsTouched(); }
  }

  updateValidators() {
    if (!this.bookingForm) { return; }

    const doControl = this.bookingForm.get('doAdress');
    const durationControl = this.bookingForm.get('duration');
    const flightNumberControl = this.bookingForm.get('flightNumber');

    if (this.booking.serviceType === 'transfer') {
      doControl.setValidators(Validators.required);
      durationControl.clearValidators();
    } else { // perHour
      doControl.clearValidators();
      durationControl.setValidators(Validators.required);
    }

    if (this.isAirportPickup) {
      flightNumberControl.setValidators(Validators.minLength(3));
    } else {
      flightNumberControl.clearValidators();
    }

    doControl.updateValueAndValidity();
    durationControl.updateValueAndValidity();
    flightNumberControl.updateValueAndValidity();
  }
  addCountryRestictionsToListeners() {
    if (this.autocompletePu == null || this.autocompleteDo == null ) {return; }
    if (this.requestedCity != null ) {
      //  si tenemos una ciudad selecionada se restringe por el pais de esta ciudad
      console.log('1 : autocompletePu.setComponentRestrictions ' + this.requestedCity.country.iso2.toLowerCase());
      this.autocompletePu.setComponentRestrictions({
        country: [this.requestedCity.country.iso2.toLowerCase()],
      });
      this.autocompleteDo.setComponentRestrictions({
        country: [this.requestedCity.country.iso2.toLowerCase()],
      });
    } else {
      const countryDropDown = this.bookingForm.controls.serviceCountry.value;
      if ( countryDropDown != null ) {
        // si tenemos un pais selecionado se restringe por este mismo
        const country: Country = this.countries.find(a => a.name === countryDropDown);
        if (country != null) {
          console.log('2 : autocompletePu.setComponentRestrictions ' + country.iso2.toLowerCase());
          this.autocompletePu.setComponentRestrictions({
            country: [country.iso2.toLowerCase()],
          });
          this.autocompleteDo.setComponentRestrictions({
            country: [country.iso2.toLowerCase()],
          });
        }else {
          console.log('3 : autocompletePu.setComponentRestrictions to null' );
          this.autocompletePu.setComponentRestrictions({
            country: [],
          });
          this.autocompleteDo.setComponentRestrictions({
            country: [],
          });
        }
      } else {
        console.log('4 : autocompletePu.setComponentRestrictions to null' );
        this.autocompletePu.setComponentRestrictions({
          country: [],
        });
        this.autocompleteDo.setComponentRestrictions({
          country: [],
        });
      }
    }
  }
  removeBoundsToListeners() {
    // como pasamos a busqueda por google quitamos el bound sobre el pickup
    if (this.autocompletePu != null ) {  this.autocompletePu.setOptions({strictBounds: false}); }
    // pero sobre el drop-off solo se quita si el pu no fue previamente selectionado y contiene
    // lo necesario para crear el bound
    if ( (this.booking.puCoordinates == null || this.booking.puCoordinates.lat == null || this.booking.puCoordinates.lng == null )
          && this.autocompleteDo != null)
    {
      // aca el pick up no tiene
      this.autocompleteDo.setOptions({strictBounds: false});
    }
  }
  addBoundToGooglePUListener(){
    if (this.autocompletePu != null) {
      if (this.requestedCity != null) {
        console.log('se crea el listener con un bound');
        console.log(this.requestedCity);
        const geolocation = new google.maps.LatLng(this.requestedCity.lat, this.requestedCity.lng);
        console.log(geolocation);
        const circle = new google.maps.Circle({center: geolocation, radius: this.maxRadiusForPuLocation});
        this.autocompletePu.setBounds(circle.getBounds());
        this.autocompletePu.setOptions({strictBounds: true});
      } else {
        this.autocompletePu.setOptions({strictBounds: false});
        console.log('NO se crea el listener con un bound');
      }
    } else {
      console.log('NO se crea el listener con un bound porque no se termino de inicializar el api de google....');
    }
  }
  addBoundToGoogleDOListener(){
    if (this.autocompleteDo != null) {
      if (this.booking.puCoordinates != null && this.booking.puCoordinates.lat != null && this.booking.puCoordinates.lng != null) {
        console.log('se crea el listener con un bound para DO al punto de inicio');
        console.log(this.booking.puCoordinates);
        const geolocation = new google.maps.LatLng(this.booking.puCoordinates.lat, this.booking.puCoordinates.lng);
        console.log(geolocation);
        const circle = new google.maps.Circle({center: geolocation, radius: this.maxRadiusForDoLocation});
        console.log(circle);
        this.autocompleteDo.setBounds(circle.getBounds());
        this.autocompleteDo.setOptions({strictBounds: true});
      } else if (this.requestedCity != null) {
        console.log('se crea el listener con un bound para DO a la ciudad de recogida');
        console.log(this.requestedCity);
        const geolocation = new google.maps.LatLng(this.requestedCity.lat, this.requestedCity.lng);
        console.log(geolocation);
        const circle = new google.maps.Circle({center: geolocation, radius: this.maxRadiusForDoLocation});
        this.autocompleteDo.setBounds(circle.getBounds());
        this.autocompleteDo.setOptions({strictBounds: true});
      } else {
        this.autocompleteDo.setOptions({strictBounds: false});
        console.log('NO se crea el listener con un bound');
      }
    } else {
      console.log('NO se crea el listener con un bound porque no se termino de inicializar el api de google....');
    }
  }

  clearGooglePuPlace(){
    // eso es necesario para  dar la oportunidad al usuario en entrar una direccion que no este en google.
    // sino cuando cambia la direccion la reserva se queda con la ultima ubicacion google selecccionada
    console.log('clearing google place for pu');
    // this.booking.puAdress = '';
    // this.bookingForm.controls.puAdress.setValue('');
    this.booking.puGoogleLocation = null;
    this.booking.puCoordinates = null;
    this.bookingForm.controls.puAdress.enable({});
    this.isAirportPickup = false;
    this.booking.isAirportPickup = false;
    this.updateValidators();
  }

  clearGoogleDoPlace(){
    // eso es necesario para  dar la oportunidad al usuario en entrar una direccion que no este en google.
    // sino cuando cambia la direccion la reserva se queda con la ultima ubicacion google selecccionada
    // this.booking.doAdress = '';
    // this.bookingForm.controls.doAdress.setValue('');
    this.booking.doGoogleLocation = null;
    this.booking.doCoordinates = null;
    this.bookingForm.controls.doAdress.enable({});
  }

  clickSearchPu(){
    console.log('click input for pu');
    console.log(this.requestedCity);
    console.log(this.bookingForm.controls.searchMode.value);
    if ( this.bookingForm.controls.searchMode.value && this.requestedCity == null ) {
      this.resultText = 'BookingSteps-70';
      this.resultClass = 'alert alert-danger';
      this.puDisabled = true;
    } else {
      this.resultText = '';
      this.resultClass = '';
      this.puDisabled = false;
    }
  }

  gotoBookingForm() {
    console.log('Going to booking');
    console.log(this.booking);
    this.beforeNextStep();
    this.bookingData.updateBooking(this.booking);
    console.log('Going to booking Ya !');
    this.router.navigate([this.localize.translateRoute('/booking')]);
    //this.insideStepper = true;
  }
  sendStepStatus(value) {
    this.widgetEvent.emit(value);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  /**
   * Load location data asynchronously without blocking the UI
   * Now returns a Promise to track completion
   */
  private async loadLocationData(): Promise<void> {
    try {
      // Load countries
      const countriesData = await this.locationService.getCountries();
      this.countries = countriesData.sort((a, b) => a.name.localeCompare(b.name));

      // Initialize localName with name for all countries
      this.countries.forEach(c => {
        c.localName = c.name;
      });

      // Handle country translations
      const countryTranslations: Observable<string>[] = [];
      this.countries.forEach(c => {
        countryTranslations.push(this.translate.get('Country.' + c.name));
      });

      if (countryTranslations.length > 0) {
        const translations = await firstValueFrom(forkJoin(countryTranslations));
        for (let i = 0; i < this.countries.length; i++) {
          this.countries[i].localName = translations[i] ? translations[i] : this.countries[i].name;
        }
        this.countries = this.countries.sort((a, b) => (a.localName || a.name || '').localeCompare(b.localName || b.name || ''));
      }

      // Load cities
      const citiesData = await this.locationService.getCities();
      this.allCities = citiesData.sort((a, b) => a.name.localeCompare(b.name));
      this.cities = this.allCities;

      // Initialize localName with name for all cities
      this.allCities.forEach(c => {
        c.localName = c.name;
      });

      // Handle city translations
      const cityTranslations: Observable<string>[] = [];
      this.allCities.forEach(c => {
        cityTranslations.push(this.translate.get('City.' + c.name));
      });

      if (cityTranslations.length > 0) {
        const translations = await firstValueFrom(forkJoin(cityTranslations));
        for (let i = 0; i < this.allCities.length; i++) {
          this.allCities[i].localName = translations[i] ? translations[i] : this.allCities[i].name;
        }
        this.allCities = this.allCities.sort((a, b) => (a.localName || a.name || '').localeCompare(b.localName || b.name || ''));
        this.cities = this.allCities;
      }

      // Load airports
      const airportsData = await this.locationService.getAirports();
      this.allAirports = airportsData.sort((a, b) => a.name.localeCompare(b.name));

      // Initialize localName with name for all airports
      this.allAirports.forEach(ap => {
        ap.localName = ap.name;
      });

      // Handle airport translations
      const airportTranslations: Observable<string>[] = [];
      this.allAirports.forEach(ap => {
        airportTranslations.push(this.translate.get('Airport.' + ap.name));
      });

      if (airportTranslations.length > 0) {
        const translations = await firstValueFrom(forkJoin(airportTranslations));
        for (let i = 0; i < this.allAirports.length; i++) {
          this.allAirports[i].localName = translations[i] ? translations[i] : this.allAirports[i].name;
        }
        this.allAirports = this.allAirports.sort((a, b) => (a.localName || a.name || '').localeCompare(b.localName || b.name || ''));
      }

      this.ref.detectChanges();

    } catch (error) {
      console.error('Error loading location data:', error);
      this.ref.detectChanges();
      throw error;
    }
  }


  openPickupMap() {
    if (this.booking.puCoordinates != null && this.booking.puCoordinates.lng != null && this.booking.puCoordinates.lat != null) {
      const mapPopupPickup = this.dialog.open(this.mapPopupComponent);
      this.subscriptions.push (mapPopupPickup.afterClosed().subscribe(result => {
        if (result) {
          console.log(result);
          if (this.booking.puCoordinates.lat !== result.lat || this.booking.puCoordinates.lng !== result.lng) {
            console.log('se detecto un cambio en el punto del mapa');
            this.reverseGeocode(result.lat, result.lng).then(data => {
              const location: google.maps.places.PlaceResult = JSON.parse(data);
              this.booking.puAdress = location.formatted_address;
              this.booking.puGoogleLocation = location;
              this.bookingForm.get('puAdress').setValue(this.booking.puAdress);
              console.log('updated address ' + this.booking.puAdress);
            }, error => {
              console.log('error updating address ' + error);
            });
          }
          this.booking.puCoordinates = new Coordinates();
          this.booking.puCoordinates.lat = result.lat;
          this.booking.puCoordinates.lng = result.lng;
        }
      }));
      mapPopupPickup.componentInstance.lat = this.booking.puCoordinates.lat;
      mapPopupPickup.componentInstance.lng = this.booking.puCoordinates.lng;
      firstValueFrom(this.translate.get('BookingSteps-43')).then(title => {
        mapPopupPickup.componentInstance.title = title;
      });
    }
  }
  openDropOffMap() {
    if (this.booking.doCoordinates != null && this.booking.doCoordinates.lng != null && this.booking.doCoordinates.lat != null ) {
      const mapPopupDropoff = this.dialog.open(this.mapPopupComponent);
      this.subscriptions.push (mapPopupDropoff.afterClosed().subscribe(result => {
        if (result) {
          console.log(result);
          if (this.booking.doCoordinates.lat !== result.lat || this.booking.doCoordinates.lng !== result.lng) {
            console.log('se detecto un cambio en el punto del mapa');
            this.reverseGeocode(result.lat, result.lng).then(data => {
              const location: google.maps.places.PlaceResult = JSON.parse(data);
              this.booking.doAdress = location.formatted_address;
              this.booking.doGoogleLocation = location;
              this.bookingForm.get('doAdress').setValue(this.booking.doAdress);
              console.log('updated address ' + this.booking.doAdress);
            }, error => {
              console.log('error updating address ' + error);
            });
          }
          this.booking.doCoordinates = new Coordinates();
          this.booking.doCoordinates.lat = result.lat;
          this.booking.doCoordinates.lng = result.lng;
        }
      }));
      mapPopupDropoff.componentInstance.lat = this.booking.doCoordinates.lat;
      mapPopupDropoff.componentInstance.lng = this.booking.doCoordinates.lng;
      firstValueFrom(this.translate.get('BookingSteps-44')).then(title => {
        mapPopupDropoff.componentInstance.title = title;
      });
    }
  }

  beforeNextStep() {
    console.log('beforeNextStep');
    this.submitted = true;
    this.bookingForm.markAllAsTouched();
    console.log(this.booking.flightNumber);
    console.log(this.booking.isAirportPickup);
    console.log(this.requestedCity);
    console.log(this.booking.serviceType);
    console.log(this.requestedCity);
    if ( this.requestedCity == null ) {
      if (this.booking.puGoogleLocation && this.booking.puGoogleLocation.address_components) {
        this.booking.serviceCity = this.locationService.extractCityFromGooglePlace(this.booking.puGoogleLocation);
        this.booking.serviceCountry = this.locationService.extractCountryFromGooglePlace(this.booking.puGoogleLocation);
      }
    } else {
      this.booking.serviceCity = this.requestedCity.name;
      this.booking.serviceCountry = this.requestedCity.country.name;
      this.booking.city = this.requestedCity;
    }
    if (this.booking.serviceType === 'transfer') {
      console.log('Actualizando duracion a la de traslado');
      this.booking.duration = 1;
    }
    // esto abajo es para estar seguro que lo que esta en el campo de direcciones se coloca bien en la reserva si el usuarion no eligio
    // un elemento de google places
    if ( this.booking.puGoogleLocation == null) { this.booking.puAdress = this.bookingForm.controls.puAdress.value; }
    if ( this.booking.doGoogleLocation == null) { this.booking.doAdress = this.bookingForm.controls.doAdress.value; }
    this.booking.discountCode = '';
    this.bookingData.updateBooking(this.booking);
    if (this.insideStepper && this.bookingForm.valid && this.nextButton) {
      this.nextButton.nativeElement.click();
    }
  }
  submit() {
    this.submitted = true;
  }

  reverseGeocode( lat: number, lng: number): Promise<string> {
      const latlng = new google.maps.LatLng(lat, lng);
      let address = '';
      return new Promise((data, error) => {
        this.geoCoder.geocode({location: latlng}, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              address = results[0].formatted_address;
              console.log('found address doing reverse geocoding' + address);
              data(JSON.stringify(results[0]));
            } else {
              error('No results found');
            }
          } else {
            error('Geocoder failed due to: ' + status);
          }
        });
      });
  }
  newBooking() {
    this.bookingData.newBooking(this.booking);
  }
  async localNameExtract(prefix: string, suffix: string) {
    await firstValueFrom(this.translate.get(prefix + '.' + suffix));
  }
}
